import { GroupsRequestParams } from '../../api/nm-types'
import { FilterBy } from '../common/Filters/FilterView/FilterTemplate'

enum ListGroupFilterKey {
  name = 'name',
}

export function mapGroupFilterToUrlParam(filter: FilterBy): Partial<GroupsRequestParams> {
  if ('value' in filter) {
    switch (filter.key) {
      case ListGroupFilterKey.name:
        return { filter: filter.value }
    }
  }
  return {}
}

export function mapUrlParamToGroupFilter(key: keyof GroupsRequestParams, value: string): FilterBy | undefined {
  switch (key) {
    case 'filter':
      return {
        key: ListGroupFilterKey.name,
        operator: 'matches',
        value,
      }
  }
  return undefined
}
